import {Column, Entity, JoinColumn, ManyToMany, ManyToOne, OneToOne, PrimaryColumn, PrimaryGeneratedColumn} from "typeorm"
import { Client } from "./Client"
import { Product } from "./Products"

@Entity()
export class ProductPriceOverride {

	@PrimaryGeneratedColumn()
	id?: number

	@ManyToOne(() => Product, (product) => product.priceOverrides)
	@JoinColumn()
	product?: Product

	@ManyToOne(() => Client, (client) => client.priceOverrides)
	@JoinColumn()
	client?: Client

	@Column({ type:"float", default : 0})
  override?: number

}